import type { Measurement } from '../api/types'
import { formatAgo, formatDateTime } from '../lib/format'
import { isMeta, seriesLabel } from '../lib/measurement'

export function MeasurementNote({ value, compact = false }: { value: Measurement; compact?: boolean }) {
  const stale = value.xn_status === 'stale' || Object.values(value.metric_sources ?? {}).some((m) => m?.is_stale)
  return <p className="text-xs text-pretty text-muted" title={`Счётчики и ×N каждой серии считаются отдельно${value.metrics_at ? ` · ${formatDateTime(value.metrics_at)}` : ''}`}>
    {seriesLabel(value)}{stale && ' · устарело'}
    {value.metrics_at && ` · замер ${compact ? formatAgo(value.metrics_at) : formatDateTime(value.metrics_at)}`}
    {isMeta(value) && value.xn_status === 'warmup' && ' · набираем базу для ×N'}
  </p>
}
